import { useState } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('name', formData.name);
      formBody.append('email', formData.email);
      formBody.append('phone', formData.phone);
      formBody.append('service', formData.service);
      formBody.append('message', formData.message);

      const response = await fetch('https://readdy.ai/api/form/d5j6hgeihetfqh7m5ljg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', phone: '', service: '', message: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  return (
    <section id="contact" className="py-24 bg-[#0F0F0F]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-5 gap-12">
          <div className="lg:col-span-2 space-y-8">
            <div>
              <h2 className="text-4xl lg:text-5xl font-serif text-white leading-tight mb-6">
                Let's Create<br />
                Your <span className="bg-gradient-to-r from-[#F2A35E] to-[#F6C1A1] bg-clip-text text-transparent">Success</span><br />
                Story
              </h2>
              <p className="text-gray-400 leading-relaxed">
                Ready to transform your OnlyFans presence? Get in touch with our team and start your journey to success today.
              </p>
            </div>

            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-2xl text-[#F6C1A1]"></i>
                </div>
                <div>
                  <p className="text-sm text-gray-400 mb-1">Email</p>
                  <a href="mailto:somosofm@venezia.work" className="text-white hover:text-[#F2A35E] transition-colors duration-300">
                    somosofm@venezia.work
                  </a>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-2xl text-[#F6C1A1]"></i>
                </div>
                <div>
                  <p className="text-sm text-gray-400 mb-1">Phone</p>
                  <a href="tel:+18001234567" className="text-white hover:text-[#F2A35E] transition-colors duration-300">
                    +1 641 888 6214
                  </a>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-2xl text-[#F6C1A1]"></i>
                </div>
                <div>
                  <p className="text-sm text-gray-400 mb-1">Location</p>
                  <p className="text-white">Caribbean Islands</p>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="bg-[#7B4A5A]/10 backdrop-blur-sm rounded-3xl p-8 lg:p-10">
              <form id="contact-form" data-readdy-form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Your Name"
                      required
                      className="w-full px-6 py-4 bg-transparent border-2 border-white/30 rounded-lg text-white placeholder-[#F6C1A1] focus:border-[#F2A35E] focus:outline-none transition-colors duration-300 text-sm"
                    />
                  </div>
                  <div>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Your Email"
                      required
                      className="w-full px-6 py-4 bg-transparent border-2 border-white/30 rounded-lg text-white placeholder-[#F6C1A1] focus:border-[#F2A35E] focus:outline-none transition-colors duration-300 text-sm"
                    />
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="Phone Number"
                      className="w-full px-6 py-4 bg-transparent border-2 border-white/30 rounded-lg text-white placeholder-[#F6C1A1] focus:border-[#F2A35E] focus:outline-none transition-colors duration-300 text-sm"
                    />
                  </div>
                  <div>
                    <select
                      name="service"
                      value={formData.service}
                      onChange={handleChange}
                      required
                      className="w-full px-6 py-4 bg-transparent border-2 border-white/30 rounded-lg text-white focus:border-[#F2A35E] focus:outline-none transition-colors duration-300 text-sm cursor-pointer"
                      style={{ colorScheme: 'dark' }}
                    >
                      <option value="" className="bg-[#0F0F0F]">Select Service</option>
                      <option value="starter" className="bg-[#0F0F0F]">Starter Package</option>
                      <option value="professional" className="bg-[#0F0F0F]">Professional Package</option>
                      <option value="elite" className="bg-[#0F0F0F]">Elite Package</option>
                      <option value="consultation" className="bg-[#0F0F0F]">Free Consultation</option>
                    </select>
                  </div>
                </div>

                <div>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Tell us about your goals and how we can help..."
                    rows={5}
                    maxLength={500}
                    required
                    className="w-full px-6 py-4 bg-transparent border-2 border-white/30 rounded-lg text-white placeholder-[#F6C1A1] focus:border-[#F2A35E] focus:outline-none transition-colors duration-300 resize-none text-sm"
                  ></textarea>
                  <p className="text-xs text-gray-400 mt-1">{formData.message.length}/500 characters</p>
                </div>

                {submitStatus === 'success' && (
                  <div className="bg-green-500/20 border border-green-500/50 text-green-300 px-4 py-3 rounded-lg text-sm">
                    Thank you for reaching out! We'll get back to you within 24 hours.
                  </div>
                )}

                {submitStatus === 'error' && (
                  <div className="bg-red-500/20 border border-red-500/50 text-red-300 px-4 py-3 rounded-lg text-sm">
                    Something went wrong. Please try again or email us directly.
                  </div>
                )}

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full py-4 px-8 bg-[#F2A35E] text-white font-semibold rounded-lg hover:bg-[#C77A5A] transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
                >
                  {isSubmitting ? 'Sending...' : 'Send Message'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
